module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0006#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0007#intro"
    }
  }, [_vm._v("Introduction: Sun Turtles and Superstorms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0009#ch01"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v("  At the Water’s Edge: From the Aquatic Zone to the Emergent Marsh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0011#ch02"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v("  Wet Meadows: Not Too Dry, Not Too Wet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0013#ch03"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v("  Pond-Meadow-Forest, Repeat: The Beaver’s Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0015#ch04"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v("  Stuck in the Muck: Bogs and Fens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0017#ch05"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v("  Wooded Wetlands: Basin Castles and Big-River Swamps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0019#ch06"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v("  Vernal Pools: Believing in Wetlands That Aren’t Always There")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0021#ch07"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v("  Salt Marshes: A Disappearing Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0022#ch08"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v("  Wetland Restoration: Changing Techniques, Changing Goals, Changing Climate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0023#ch09"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v("  Beauty, Ethics, and Inspiration")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0024#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0025#refs"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikoning0026#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7778026a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-koning-0005.vue
// module id = 66
// module chunks = 0